import { Component, Injector } from '@angular/core';
import { BaseAppComponent } from './submodules/angular-ui-common/base-app.component';

@Component({
  selector: 'app-root',
  template: `<app-loading-screen *ngIf="!showApp"></app-loading-screen>
             <router-outlet *ngIf="showApp"></router-outlet>`
})
export class AppComponent extends BaseAppComponent {

  constructor(protected _injector: Injector) {
    super(_injector);
  }
}
